function isEqual(o1: unknown, o2: unknown): boolean {
	if (o1 === o2) {
		return true;
	}

	if (Array.isArray(o1) && Array.isArray(o2)) {
		if (o1.length !== o2.length) {
			return false;
		}
		return o1.every((i1, i) => isEqual(i1, o2[i]));
	}

	if (typeof o1 === "object" && !!o1 && typeof o2 === "object" && !!o2) {
		const k1 = Object.keys(o1).sort();
		const k2 = Object.keys(o2).sort();
		if (!isEqual(k1, k2)) {
			return false;
		}

		// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		return k1.every((k) => isEqual((o1 as any)[k], (o2 as any)[k]));
	}

	return false;
}

export { isEqual };
